import { defineComponent, nextTick, onMounted } from "vue";
import Utils from "../utils/Utils";

export default defineComponent({
    template: `
        <div class="SmeLayout">
            <div class="wrapper" :class="[ 'wrapper--' + wrapper ]">
                <div class="SmeLayout__body">
                    <slot></slot>
                </div>
            </div>
        </div>
    `,

    props: {
        wrapper: { type: String, default: '880' },
    },

    setup(props, ctx) {
        Utils.attachBodyClass(['body--SmeLayout']);

        onMounted(() => {
            nextTick(() => {
                let el = '.SmeLayout';

                if ($('.header--preheader').length) {
                    el = '.header--preheader';
                }

                Utils.scrollToEl($(el));
            });
        });
    },
});
